import axios from "axios";

export const PG_TOKEN_KEY = "pg_token";
export const PG_OPERATOR_KEY = "pg_operator";

/**
 * PG 現場兌換頁專用的 axios instance。
 *
 * baseURL 與主 API 相同（REACT_APP_API_URL），身分是 /pg/login 換來的 access_token
 * （存在 localStorage 的 pg_token），與會員中心的 api_token 各自獨立、不互相覆蓋。
 * token 失效（401）時清掉，由 PgLoginGuard 導回登入頁。
 */
function apiPg() {
	const instance = axios.create({
		baseURL: process.env.REACT_APP_API_URL,
	});

	instance.interceptors.request.use(
		(config) => {
			const token = localStorage.getItem(PG_TOKEN_KEY);
			if (token) {
				config.headers["Authorization"] = `Bearer ${token}`;
			}
			return config;
		},
		(error) => Promise.reject(error),
	);

	instance.interceptors.response.use(
		(res) => res.data,
		(error) => {
			if (error.response?.status === 401) {
				localStorage.removeItem(PG_TOKEN_KEY);
				localStorage.removeItem(PG_OPERATOR_KEY);
			}
			return Promise.reject(error);
		},
	);

	return instance;
}

export default apiPg();
